<template>
    <BaseChip :size="size" :class="stateClasses[state]">
        <template #leading><slot name="leading" /></template>
        <slot />
        <template #trailing><slot name="trailing" /></template>
    </BaseChip>
</template>

<script lang="ts">
import type { BaseChipSize } from "~vue/components/BaseChip.vue";

export type StatusChipState = "neutral" | "active" | "done" | "pending" | "overdue";

interface StatusChipProps {
    state?: StatusChipState;
    size?: BaseChipSize;
}
</script>

<script setup lang="ts">
import BaseChip from "~vue/components/BaseChip.vue";

const { state = "neutral", size = "sm" } = defineProps<StatusChipProps>();

const stateClasses: Record<StatusChipState, string> = {
    neutral: "state-neutral",
    active: "state-positive",
    done: "state-positive",
    pending: "state-pending",
    overdue: "state-overdue",
};
</script>

<style scoped>
@layer components {
    .state-neutral {
        --base-chip-bg: var(--color-chip-neutral-bg);
        --base-chip-text: var(--color-chip-neutral-text);
    }

    .state-positive {
        --base-chip-bg: var(--color-chip-status-done-bg);
        --base-chip-text: var(--color-chip-status-done-text);
    }

    .state-pending {
        --base-chip-bg: var(--color-chip-status-pending-bg);
        --base-chip-text: var(--color-chip-status-pending-text);
    }

    .state-overdue {
        --base-chip-bg: var(--color-chip-status-overdue-bg);
        --base-chip-text: var(--color-chip-status-overdue-text);
    }
}
</style>
